import axios from 'axios'

const axiosInstance = axios.create({
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export const brandParams = {
  getBrandParams: async function (baseUrl, app) {
    try {
      let res = await axiosInstance.request({
        method: 'GET',
        url: `${baseUrl}/api/v1/params/${app}`
      })
      return res.data
    } catch (e) {
      return { success: false, code: 500 }
    }
  }
}
